export default __webpack_public_path__ + "cb078e6efbff084155ea435d5b931454.svg";